import i18n from "i18next";

import enTranslation from "./assets/locales/en/translation.json";
import frTranslation from "./assets/locales/fr/translation.json";

i18n.addResourceBundle("en", "translation", enTranslation, true);
i18n.addResourceBundle("fr", "translation", frTranslation, true);

export default i18n;